import { SVGProps } from 'react';

const SvgRoundGraph = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      stroke="#FF8F44"
      strokeLinecap="round"
      strokeWidth={2}
      d="M16 2.668c7.364 0 13.333 5.97 13.333 13.333S23.363 29.335 16 29.335 2.667 23.365 2.667 16c0-3.73 1.531-7.102 4-9.522"
    />
    <path
      stroke="#FF8F44"
      strokeLinecap="round"
      strokeWidth={2}
      d="M6.667 16.001A9.333 9.333 0 0 0 16 25.335a9.333 9.333 0 1 0 0-18.667"
    />
    <path stroke="#FF8F44" strokeLinecap="round" strokeWidth={2} d="M16 21.335a5.333 5.333 0 0 0 0-10.667" />
  </svg>
);
export default SvgRoundGraph;
